<template>
    <Modal @close="onClose">
        <template #content>
            <Standard class="br-m"
                uiTitle="delete"
                :uiTitleEntity="type"
                :uiIsGlobal="false"
                @close="onClose">
                <template #body>
                    <Warning :lbl="warningText" icon="shield" class="sm-b-l" />
                </template>
                <template #footer>
                    <AthButton class="el--s-m el--t-primary"
                        type="submit"
                        lbl="mead.confirm"
                        @click.prevent.stop="submit" />
                </template>
            </Standard>
        </template>
    </Modal>
</template>
<script>
import Modal from '../../standalone_modals/Modal.vue';
import Standard from '../../modal-styles/Standard.vue';
import Warning from '../../../atoms/Warning.vue';
import AthButton from '../../../atoms/Button.vue';

export default {
    props: {
        /**
         * The type of item being deleted, passed in from the parent and displayed
         * in the modal's title (e.g. "Delete <type>").
         */
        type: {type: String, default: () => ''},
        /**
         * Localization key for the warning message displayed in the modal body,
         * explaining the consequences of deleting this widget.
         */
        warningText: {type: String, default: () => ''},
    },
    components: {Modal, Standard, Warning, AthButton},
    methods: {
        submit: function () {
            this.$emit('confirm');
        },
        onClose: function () {
            this.$emit('close');
        },
    },
};
</script>
